import React, { useContext } from 'react';
import { Title, Divider } from 'components';
import { AuthContext } from 'contexts';
import { checkUserBillingPermission } from 'utils';
import { sendPaymentUpdatedNotification } from 'api/NotificationController';
import AppointmentDeskContext from '../AppointmentDeskContext';
import { StyledBox } from '../StyledComponents';
import ManageCard from '../../../components/ManageCard';
import { CanManageBillingProfileType } from '../../SubscriptionsPaymentsPage/SubscriptionsPageContext';

const PaymentMethod: React.FC = () => {
  const { owner, subscriptionType, userId, fetchStripeCustomerId } = useContext(
    AppointmentDeskContext,
  );
  const { auth } = useContext(AuthContext);

  const canManageBilling = (): CanManageBillingProfileType => {
    if (subscriptionType === 'org') {
      if (!checkUserBillingPermission(auth)) {
        const { firstName, lastName, email } = owner || {};
        return {
          response: false,
          message: owner
            ? `Only ${firstName} ${lastName} (Account Owner, ${email}) may update payment method.`
            : 'Only your Brokerage Owner can update the payment method.',
        };
      }
    } else if (userId !== auth.id) {
      return {
        response: false,
        message: 'Only the owner of this account may update payment method.',
      };
    }

    if (auth.assumingUserId || auth.isAssumedNotBB || auth.assumerIdMlsStaff) {
      return {
        response: false,
        message: 'You cannot manage billing while assuming a user.',
      };
    }

    return {
      response: true,
    };
  };

  const handleCardUpdateSuccess = () => {
    fetchStripeCustomerId();
    if (subscriptionType === 'org' && auth.role !== 'OWNER') {
      sendPaymentUpdatedNotification();
    }
  };

  return (
    <>
      <StyledBox
        $py={2.5}
        $flexDirection="column"
        data-cy="payment-methods-container"
      >
        <Title level={3} data-cy="payment-method-title">
          Payment Method
        </Title>
        <ManageCard
          productType="appointmentDesk"
          canManageBilling={canManageBilling()}
          // We currently don't care about overdue balances when adding a Live Concierge Service plan
          isSubscriptionOverdue={{ response: false }}
          userId={userId}
          onCardUpdateSuccess={handleCardUpdateSuccess}
          isBillingPage={false}
          stripePk={process.env.STRIPE_PK!}
        />
      </StyledBox>
      <Divider />
    </>
  );
};

export default PaymentMethod;
